<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Data Options'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'DataOptionSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        loading: false,
        tableData: [],
        entityName: 'data-option',
        editEntityScreen: 'Admin - Edit/View Data Option',
        fields: [
          { header: 'Name', prop: 'name', hideByDefault: false },
          { header: 'Code', prop: 'code', hideByDefault: false },
          { header: 'Option Type', prop: item => item.optionType !== null ? item.optionType.name : '', hideByDefault: true },
          { header: 'Value (alpha)', prop: 'valueAlpha', hideByDefault: true },
          { header: 'Value (numeric)', prop: 'valueNumeric', hideByDefault: true },
          { header: 'Value (T/F)', prop: 'valueBoolean', hideByDefault: true },
          { header: 'Notes', prop: 'notes', hideByDefault: true }
        ]
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/DataOption/DataOptionSearchResults.vue